import React, { Component } from "react";
import { connect } from "react-redux";
import Card from "react-bootstrap/Card";
import Navbar from "react-bootstrap/Navbar";
import Container from "react-bootstrap/Container";
import Button from "Components/Button";
import ListGroup from "react-bootstrap/ListGroup";
import styled from "styled-components";
import ProjectActions, { ProjectSelectors } from "Redux/ProjectRedux";
import LoadingIcon from "Components/LoadingIcon";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import { Fonts, Colors } from "Themes";
import navRoutes from "Navigation/NavRoutes";
import { mobileSize } from "Themes/Metrics";
import { CustomContainer } from "Themes/StyledComponents";
import { IoIosCheckmarkCircle } from "react-icons/io";
import { AuthenticationSelectors } from "Redux/AuthenticationRedux";

const MainCard = styled(Card)`
  width: 100%;
  margin: auto;
  @media ${mobileSize.large} {
    width: 100%;
  }
`;

const SliderContainer = styled.div`
  padding: 10px;
  width: 60%;
  margin: auto;
  margin-bottom: 30px;
  @media ${mobileSize.large} {
    width: 100%;
  }
`;

const ProjectUpdateAvatar = styled.img`
  height: 50px;
  width: 50px;
  border-radius: 100px;
  margin-left: 10px;
`;

const RatingGivenText = styled.div`
  font-size: ${Fonts.fontSize.medium}px;
  margin-left: 10px;
  display: flex;
  align-items: center;
`;

class UpdateDetailContainer extends Component {
  state = {
    fetching: true,
    error: null,
    rating: null,
  };
  async componentDidMount() {
    const {
      match: { params },
    } = this.props;

    const resolve = {
      onSuccess: () => this.setState({ fetching: false, error: null }),
      onFailure: (e) => this.setState({ fetching: false, error: e }),
    };

    await this.props.getUpdateDetail(params.update_id, resolve);
  }

  _sliderChange = (vals) => {
    this.setState({
      rating: vals,
    });
  };

  _submitRating = async () => {
    const { rating } = this.state;
    const {
      updateDetail: { id },
      submitRating,
    } = this.props;
    this.setState({ fetching: true });
    const resolve = {
      onSuccess: () => this.setState({ fetching: false, error: null }),
      onFailure: (e) => this.setState({ fetching: false, error: e }),
    };
    const data = {
      id,
      rating,
    };
    await submitRating(data, resolve);
  };

  _renderRating = (rating) => (
    <div style={{ padding: 10, fontFamily: Fonts.primaryFontFamily }}>
      {rating}
    </div>
  );

  render() {
    const { fetching } = this.state;

    if (fetching)
      return (
        <Container
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: "10%",
          }}
        >
          <LoadingIcon />
        </Container>
      );

    const { updateDetail, history, isAuthenticated } = this.props;
    const { update, updateDetails, project, userGivenRating } = updateDetail;

    return (
      <CustomContainer style={{ marginTop: "5%" }}>
        <MainCard>
          <ListGroup variant="flush">
            <ListGroup.Item style={{ display: "flex" }}>
              <div
                style={{
                  flex: 1,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <Navbar.Brand>{update}</Navbar.Brand>
              </div>
              <div
                style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}
              >
                <Button
                  onClick={() =>
                    history.push(`${navRoutes.explore}/${project.id}`)
                  }
                  variant={"info"}
                  style={{
                    color: Colors.mainColor,
                    backgroundColor: "white",
                    border: `solid 2px white`,
                    textAlign: "right",
                  }}
                >
                  View Project
                  <ProjectUpdateAvatar
                    src={project.projectAvatar}
                    alt={"Not found"}
                  />
                </Button>
              </div>
            </ListGroup.Item>
            <ListGroup.Item
              style={{
                paddingTop: 40,
                paddingBottom: 80,
                fontSize: Fonts.fontSize.small,
              }}
            >
              {updateDetails}
            </ListGroup.Item>
            {userGivenRating ? (
              <ListGroup.Item
                style={{ display: "flex", justifyContent: "flex-end" }}
              >
                {isAuthenticated ? (
                  <>
                    <IoIosCheckmarkCircle fontSize={40} color={"green"} />
                    <RatingGivenText>
                      You have rated this update
                    </RatingGivenText>
                  </>
                ) : (
                  <div>
                    <Button onClick={() => history.push(navRoutes.login)}>
                      You need to log in to rate a project
                    </Button>
                  </div>
                )}
              </ListGroup.Item>
            ) : (
              <ListGroup.Item
                style={{ display: "flex", flexDirection: "column" }}
              >
                <h4 style={(Fonts.paragraphFont, { textAlign: "center" })}>
                  How good is this update?
                </h4>
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    marginTop: 20,
                  }}
                >
                  <SliderContainer>
                    <Slider
                      onAfterChange={this._sliderChange}
                      trackStyle={{
                        backgroundColor: "green",
                        height: 10,
                      }}
                      railStyle={{
                        height: 10,
                      }}
                      handleStyle={{
                        height: 20,
                        width: 20,
                        border: "solid 3px green",
                      }}
                    />
                  </SliderContainer>
                </div>
                <Button
                  style={{ width: "20%", margin: "auto" }}
                  onClick={this._submitRating}
                >
                  Rate
                </Button>
              </ListGroup.Item>
            )}
          </ListGroup>
        </MainCard>
      </CustomContainer>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    updateDetail: ProjectSelectors.getUpdateDetail(state),
    isAuthenticated: AuthenticationSelectors.getAuthenticated(state),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getUpdateDetail: (data, resolve) =>
      dispatch(ProjectActions.updateDetailRequest(data, resolve)),
    submitRating: (data, resolve) =>
      dispatch(ProjectActions.submitRatingRequest(data, resolve)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateDetailContainer);
